import {ajax, getRequestUrl, uploadImg} from "../request";

export default {
  set_fistList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/fistList'), data, {
      method,
    });
  },

  set_prettyLockList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/prettyLockList'), data, {
      method,
    });
  },

  set_prettyLockSet(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/prettyLockSet'), data, {
      method,
    });
  },

  set_appVension(data, method) {
    return ajax('post', getRequestUrl('/version/info'), data, {
      method,
    });
  },

  setMinimumVersion(data, method) {
    return ajax('post', getRequestUrl('/version/setMinimumVersion'), data, {
      method,
    });
  },

  androidVension(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/androidVension'), data, {
      method,
    });
  },

  skinList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/skinList'), data, {
      method,
    });
  },

  skinSet(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/skinSet'), data, {
      method,
    });
  },

  set_officialAccountSet(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/officialAccountSet'), data, {
      method,
    });
  },

  set_officialAccountList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/officialAccountList'), data, {
      method,
    });
  },

  set_task(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/task'), data, {
      method,
    });
  },

  set_blackList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/blackList'), data, {
      method,
    });
  },

  set_blackSet(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/blackSet'), data, {
      method,
    });
  },

  set_backendVension(data, method) {
    return ajax('post', getRequestUrl('/version/setControlVersion'), data, {
      method,
    });
  },

  set_shopRuleList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/shopRuleList'), data, {
      method,
    });
  },

  set_shopRuleOn(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/shopRuleOn'), data, {
      method,
    });
  },

  set_addRule(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/addRule'), data, {
      method,
    });
  },

  set_feedbackList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/feedbackList'), data, {
      method,
    });
  },

  set_checkFeedback(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/checkFeedback'), data, {
      method,
    });
  },

  set_shopIdList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/shopIdList'), data, {
      method,
    });
  },

  set_operateNumber(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/operateNumber'), data, {
      method,
    });
  },

  set_getUserList(data) {
    return uploadImg(getRequestUrl('/api/Setting/getUserList'), data)
  },

  set_userAdd(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/userAdd'), data, {
      method,
    });
  },

  gameBlackList(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/gameBlackList'), data, {
      method,
    });
  },

  gameBlackSet(data, method) {
    return ajax('post', getRequestUrl('/api/Setting/gameBlackSet'), data, {
      method,
    });
  },

  // export aliases kept for compatibility
  // ... (other methods removed from top-level declaration)
}



// WEBPACK FOOTER //
// ./src/js/https/setting.js